import { StytchUIClient } from '@stytch/vanilla-js';

const publicToken = import.meta.env.VITE_PUBLIC_STYTCH_PUBLIC_TOKEN;

if (!publicToken) {
  console.warn('VITE_PUBLIC_STYTCH_PUBLIC_TOKEN is not set');
}

export const stytch = new StytchUIClient(publicToken || '');

export const SESSION_DURATION_MINUTES = 60 * 24 * 14; // 14 days

// Stytch's own storage keys (cookies + localStorage) — cleared directly so a
// sign-out can never get stuck. Revoking server-side can fail (network blip,
// an already-odd session); when it does, the old code left the session fully
// intact with no visible error, so "sign out" silently did nothing and the
// same account kept coming back on every reload.
const STYTCH_STORAGE_KEYS = [
  'stytch_session',
  'stytch_session_jwt',
  'stytch_intermediate_session_token',
  'stytch_token_type',
];

function clearStytchCookie(name) {
  // Clear for both the current path and root, and with/without a leading
  // dot on the host, since cookies can be set at slightly different scopes.
  const host = window.location.hostname;
  const expire = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = `${name}=; ${expire}; path=/`;
  document.cookie = `${name}=; ${expire}; path=/; domain=${host}`;
  document.cookie = `${name}=; ${expire}; path=/; domain=.${host}`;
}

/**
 * Belt-and-suspenders local sign-out: clears Stytch's session cookies and
 * localStorage directly, regardless of whether the server-side revoke call
 * succeeded. Always call this from signOut so a flaky revoke can never leave
 * a stale session usable.
 */
export function clearStytchLocalSession() {
  for (const key of STYTCH_STORAGE_KEYS) {
    clearStytchCookie(key);
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore private-mode/quota errors
    }
  }
}

/** OAuth (Google/Apple) return URL — still uses /authenticate. */
export function oauthRedirectUrl() {
  return `${window.location.origin}/authenticate`;
}

/** @deprecated Use oauthRedirectUrl */
export const magicLinkRedirectUrl = oauthRedirectUrl;
